export const ValidationErrorIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M9.99996 18.3346C5.39746 18.3346 1.66663 14.6038 1.66663 10.0013C1.66663 5.3988 5.39746 1.66797 9.99996 1.66797C14.6025 1.66797 18.3333 5.3988 18.3333 10.0013C18.3333 14.6038 14.6025 18.3346 9.99996 18.3346ZM9.16663 12.5013V14.168H10.8333V12.5013H9.16663ZM9.16663 5.83464V10.8346H10.8333V5.83464H9.16663Z"
        fill="#E7704C"
      />
    </svg>
  );
};
